import { render, staticRenderFns } from "./GuppyChatBlockUserList.vue?vue&type=template&id=77993533&"
import script from "./GuppyChatBlockUserList.vue?vue&type=script&lang=js&"
export * from "./GuppyChatBlockUserList.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatBlockUserList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports